<template>

    <div class="ref_tab_item"
        :class="{active: isActive, dropTarget: isDragHover}"

        @dragover.prevent="onDragEnter($event, cat)"
        @dragleave="onDragLeave($event, cat)"
        @drop="onDrop($event, cat)">

        <div class="sight_ref_cats" >
            <div @click="$emit('click')"> {{cat.name}}</div>
            <div @click="$emit('removeCatClicked')" class="del_ref_cat"><i class="icon-close"></i></div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'CatItem',
    components: {},
    props: ['cat', 'isActive'],
    data(){
        return {
            isDragHover: false
        }
    },
    computed: {
    },
    methods: {
        isActiveCat(catId){
            return this.currentCatId == catId
        },
        onDrop(event, cat){
            this.isDragHover = false
            this.$emit('drop', event, cat)
        },
        onDragEnter(event, cat){
            this.isDragHover = true
        },
        onDragLeave(event, cat){
            this.isDragHover = false
        }

    }
}
</script>

<style lang="scss">
.ref_tab_item{
    display: block;
    text-transform: uppercase;
    padding: 4px;
    font-weight: 500;
    border-bottom: 4px solid $white;
    margin: 0 4px;
    cursor: pointer;
    transition: .3s all;
    white-space: nowrap;
    &:hover{
        border-bottom: 4px solid $grey-lighter;
        transition: .3s all;
    }
    &.active{
        border-bottom: 4px solid $info;
        transition: .3s all;
    }
    &.dropTarget{
        transform: scale(1.2);
        background: $info;
        color: $white;
    }
    .sight_ref_cats{
        display: flex;
        .del_ref_cat{
            padding-left: 8px;
            color: $danger;
            display:block;
            opacity: 0;
            width: 0;
            transition: .3s all;

        }
        &:hover{
            .del_ref_cat{
                opacity: 1;
                width: 32px;
                text-align: center;
            }
        }
    }
}


</style>